import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './SoccerGame.css';
import enGameBg from '../assets/images/-en-bg.png';
import frGameBg from '../assets/images/-fr-bg.jpg';

const SoccerGame = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const lang = (i18n.language || 'en').toLowerCase().startsWith('fr') ? 'fr' : 'en';
  const iframeSrc = `/soccer-game/index.html?lang=${lang}`;

  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  // Listen for game end message from iframe
  useEffect(() => {
    const handleMessage = async (event) => {
      // Security check - only accept messages from our own origin or the iframe
      if (event.data && event.data.type === 'GAME_ENDED') {
        console.log('Game ended with score:', event.data.score);
        
        const parsedScore = parseInt(event.data.score, 10);
        const currentScore = Number.isFinite(parsedScore) ? parsedScore : 0;
        
        // Save the last game score to localStorage
        localStorage.setItem('lastGameScore', currentScore.toString());
        
        // Get the existing best score from localStorage (BEFORE updating it)
        const storedBestScore = localStorage.getItem('bestScore');
        const previousBest = storedBestScore ? parseInt(storedBestScore, 10) : 0;
        
        // Check if this is a new personal high score
        if (!storedBestScore || currentScore > previousBest) {
          // First game ever OR beat previous best
          localStorage.setItem('bestScore', currentScore.toString());
          localStorage.setItem('isNewHighScore', 'true');
        } else if (currentScore === previousBest && previousBest > 0) {
          // Tied their previous best (still impressive)
          localStorage.setItem('isNewHighScore', 'tied');
        } else {
          // Didn't beat or tie their best
          localStorage.setItem('isNewHighScore', 'false');
        }
        
        // Navigate to initials entry
        navigate('/data-entry');
      }
    };

    window.addEventListener('message', handleMessage);

    // Cleanup listener on unmount
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [navigate]);

  return (
    <div 
      className="soccer-game-container"
      style={{ 
        backgroundImage: `url(${lang === 'fr' ? frGameBg : enGameBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
          <p>Loading Penalty Kicks Game...</p>
        </div>
      )}

      <iframe
        key={lang}
        src={iframeSrc}
        title="Soccer Penalty Kicks Game"
        className="game-iframe"
        onLoad={handleIframeLoad}
        allowFullScreen
      />
    </div>
  );
};

export default SoccerGame;